import { Component } from '@angular/core';
import { StorageService } from '../../../core/storage/storageService';
import { User } from '../../../models/users/user';

@Component({
  selector: 'app-user-profile-dialog',
  templateUrl: './user-profile-dialog.component.html',
  standalone: false,
})
export class UserProfileDialogComponent {
  user: User;

  constructor(private storageService: StorageService) {
    this.user = this.storageService.getCurrentUser();
  }

  normalDebugging() {
    // DebugService.enableNormalLogging();
  }

  advancedDebugging() {
    // DebugService.enableVerboseLogging();
  }

  noDebugging() {
    // DebugService.disableLogging();
  }
}
